import { NavItem } from '@config/nav'
import { resolvePath } from 'react-router-dom'

export const buildHref = (href: string | undefined) =>
    href ? `#${resolvePath(href).pathname}` : undefined

export const isRouteActive = (route: string | undefined) => {
    if (!route) {
        return false
    }

    const currentRoute = window.location.hash
    return (
        currentRoute.endsWith(route) &&
        (route.indexOf('new') !== -1 || currentRoute.indexOf('new') === -1)
    )
}

export const isNavActive = (item: NavItem) =>
    isRouteActive(item.href) || item.items?.some((i) => isRouteActive(i.href))
